import './program.less'

import {Block, BlockType} from 'blocks/block'
import {Blocks} from 'blocks/blocks'
import {BreakoutModel} from 'models/program/BreakoutModel'
import {ProgramdayModel} from 'models/program/ProgramdayModel'
import {ProgramSchedule} from 'models/program/ProgramModel'
import {SequenceModel} from 'models/program/SequenceModel'
import {SessionModel} from 'models/program/SessionModel'
import React from 'react'
import {Link} from 'react-router-dom'
import {LinkType, PageData} from 'types'
import {useEvent} from 'util/eventcontext'
import {useSearchParams} from 'util/hooks'
import {style} from 'util/style'
import {Hero, HeroType} from 'views/hero/hero'
import {Layout} from 'views/layout'
import {Breakoutblock} from 'views/program/blocks/breakoutblock'
import {Sequenceblock} from 'views/program/blocks/sequenceblock'
import {Sessionblock} from 'views/program/blocks/sessionblock'
import {Theme} from 'views/theme'

const styles = style('program', ['overview', 'day'])

export type SummitsLinkType = Array<{summit: string; link: LinkType}>

export const Program: React.FC<PageData & {
	hero: HeroType
	blocks: Array<BlockType>
	summits_link: SummitsLinkType
}> = data => {
	const {title, subtitle, url, hero, blocks, summits_link} = data
	const {event: activeDayPath, popup} = useSearchParams()
	const event = useEvent()
	const program = event.program
	const item = event.program.getProgramItem(popup)
	const activeDay =
		item?.day ||
		program.days.find(day => day.path === activeDayPath) ||
		program.days[0]

	return (
		<Layout page={data}>
			<div class={styles()}>
				<Hero pagetitle={title} {...hero} />
				{program.hasMultipleDays && (
					<div className={styles('days')}>
						<Theme.Container>
							{subtitle && (
								<h3 className={styles('days-subtitle')}>{subtitle}</h3>
							)}
							<div className={styles('days-row')}>
								{program.days.map(day => (
									<ProgramDay
										to={url + '?event=' + day.path}
										day={day}
										active={day === activeDay}
									/>
								))}
							</div>
						</Theme.Container>
					</div>
				)}
				<ProgramOverview
					schedule={activeDay ? activeDay.schedule : program.schedule}
					summits_link={summits_link}
				/>
				{blocks && blocks.length !== 0 && (
					<Blocks className={styles('blocks')}>
						{blocks.map((block, i) => (
							<Block key={i} {...block} />
						))}
					</Blocks>
				)}
			</div>
		</Layout>
	)
}

export const ProgramDay: React.FC<{
	to: string
	day: ProgramdayModel
	active: boolean
}> = ({to, day, active}) => {
	const {title, subtitle, theme} = day

	return (
		<Link
			className={styles
				.day()
				.mod(theme)
				.is({active})
				.toString()}
			to={to}
		>
			<div className={styles.day('content')}>
				<div className={styles.day('content-title')}>{title}</div>
				<div className={styles.day('content-subtitle')}>{subtitle}</div>
			</div>
		</Link>
	)
}

export const ProgramOverview: React.FC<{
	schedule: ProgramSchedule
	summits_link: SummitsLinkType
}> = ({schedule, summits_link}) => {
	if (!schedule || schedule.length === 0) return null

	return (
		<div className={styles.overview()}>
			<Theme.OuterContainer>
				<Theme.Container>
					{schedule.map(item => {
						if (item instanceof SessionModel)
							return <Sessionblock session={item} />
						if (item instanceof SequenceModel)
							return (
								<Sequenceblock sequence={item} summits_link={summits_link} />
							)
						if (item instanceof BreakoutModel)
							return <Breakoutblock breakout={item} />
					})}
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
